import { Directive, inject, TemplateRef } from '@angular/core';

/**
 * Defines a cell with data of column.
 */
@Directive({
  selector: '[fbSimpleTableCellDef]',
})
export class SimpleTableCellDef {
  /**
   * Template for the cell.
   */
  public readonly template = inject(TemplateRef);
}
